import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const { DriveSlotBookingContainer } = await import('@containers/Drive/DriveScheduling');
    return {
        Component: DriveSlotBookingContainer,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
